var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "guide-nav" },
    _vm._l(_vm.menuRoutes, function (item) {
      return _c(
        "div",
        {
          key: item.name,
          class: ["item", { active: _vm.activeIndex.includes(item.path) }],
          on: {
            click: function ($event) {
              return _vm.toMenu(item)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(item.meta.title) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }